/**
 * Payroll layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * Payroll is a 1.0-withheld module (returns in 1.2). This layout route
 * redirects a typed `/payroll` URL — and every nested child (`/payroll/$runId`)
 * — to `/` unless the workspace is entitled to `payroll`, which no 1.0 plan
 * grants. Renders only an `<Outlet/>` so the gate adds no visual chrome.
 * @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/payroll")({
  beforeLoad: requireModule("payroll"),
  component: Outlet,
});
